import { BaseDAO } from './baseDAO';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { HttpHeaders } from '@angular/common/http';
import { Customer } from 'anchor-shared/lib/model/entity/customer';
import { ResourceSigner, SignedResourceResponse } from './uploadDAO';

@Injectable()
export class CustomerDAO extends BaseDAO<Customer> implements ResourceSigner {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.CUSTOMER);
  }

  public getForUser(): Observable<Customer> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/user';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Customer>(url, method, null, null, headers);
  }

  public adminGetForUser(userId: number): Observable<Customer> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/admin/' + userId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Customer>(url, method, null, null, headers);
  }

  public adminGrid(): Observable<Customer[]> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/admin/grid/data';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Customer[]>(url, method, null, null, headers);
  }

  public updateFromPartial(
    userId: number,
    customer: Partial<Customer>,
  ): Observable<Customer> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/user/' + userId;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Customer>(
      url,
      method,
      null,
      customer,
      headers,
    );
  }

  public adminUpdateFromPartial(
    userId: number,
    customer: Partial<Customer>,
  ): Observable<Customer> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/admin/user/' +
      userId;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Customer>(
      url,
      method,
      null,
      customer,
      headers,
    );
  }

  public getPaymentMethod(): Observable<CustomerPaymentMethod> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/payment/method';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, null, headers);
  }

  public getPaymentMethodAsAdmin(
    userId: number,
  ): Observable<CustomerPaymentMethod> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/payment/methodAsAdmin/' +
      userId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, null, headers);
  }

  getSignedResource(
    foreignKey: string | number,
    resourceKey: string,
  ): Observable<SignedResourceResponse> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/gov-id/signed-url/' +
      foreignKey;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      key: resourceKey,
    };
    return this.apiHelper.apiCall<SignedResourceResponse>(
      url,
      method,
      null,
      data,
      headers,
    );
  }

  adminGetSignedResource(
    foreignKey: string | number,
    resourceKey: string,
  ): Observable<SignedResourceResponse> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/admin/gov-id/signed-url/' +
      foreignKey;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      key: resourceKey,
    };
    return this.apiHelper.apiCall<SignedResourceResponse>(
      url,
      method,
      null,
      data,
      headers,
    );
  }

  adminGetSignedResourceForGuestUser(
    resourceKey: string,
  ): Observable<SignedResourceResponse> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/admin/gov-id/guest-user/signed-url';
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      imgKey: resourceKey,
    };
    return this.apiHelper.apiCall<SignedResourceResponse>(
      url,
      method,
      null,
      data,
      headers,
    );
  }

  getForUserByUserId(userId: number): Observable<Customer> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/user/' + userId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<Customer>(url, method, null, null, headers);
  }

  adminCreateCustomer(userId: number): Observable<Partial<Customer>> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/admin/create-customer';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      userId: userId,
    };

    return this.apiHelper.apiCall<Partial<Customer>>(
      url,
      method,
      null,
      data,
      headers,
    );
  }

  getSessionToken(): Observable<{ sessionToken: string }> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/user/get/session-token';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<{ sessionToken: string }>(
      url,
      method,
      null,
      null,
      headers,
    );
  }
}

export interface CustomerPaymentMethod {
  token: string;
  last4: string;
  type: string;
}
